import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectIsAuthenticated, selectUser, homeRouteForRole } from '../../redux/slices/authSlice'

const GuestGuard = ({ component: Component, restricted = false }) => {
  const location        = useLocation()
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const user            = useSelector(selectUser)

  if (restricted && isAuthenticated && user) {
    const returnTo = location.state?.from?.pathname || homeRouteForRole(user.role)
    return <Navigate to={returnTo} replace />
  }
  return <Component />
}

export default GuestGuard